// Season definitions
export const seasons = {
  low: {
    ranges: [
      { start: "2025-04-01", end: "2025-05-15" },
      { start: "2025-09-21", end: "2025-10-30" },
    ],
    name: "Low Season",
    description: "April 1 - May 15, September 21 - October 30",
  },
  medium: {
    ranges: [
      { start: "2025-05-16", end: "2025-06-15" },
      { start: "2025-09-06", end: "2025-09-20" },
    ],
    name: "Medium Season",
    description: "May 16 - June 15, September 6 - September 20",
  },
  high: {
    ranges: [{ start: "2025-06-16", end: "2025-09-05" }],
    name: "High Season",
    description: "June 16 - September 5",
  },
};
